<template>
    <div>
        <v-skeleton-loader type="table-tbody" v-if="$store.state.loading"></v-skeleton-loader>

        <v-table class="result_table" density="compact" v-else style="border-radius: 5px">
            <thead class="bg-secondary">
                <tr>
                    <th>Détails</th>
                    <th>Clt</th>
                    <th>Equipe</th>
                    <th>Temps</th>

                </tr>
            </thead>
            <tbody v-if="filteredRunners.length > 0">
                <template v-for="(runner, id_runner) in filteredRunners" :key="id_runner">
                    <tr>
                        <td>
                            <v-btn density="compact" :icon="isExpanded(runner) ? 'mdi-minus' : 'mdi-plus'"
                                class="bg-primary text-white" variant="text"
                                @click="display_runner_details(runner)"></v-btn>
                        </td>
                        <td>
                            <b>{{ runner.total.clt_sexe ?? '—' }}</b>
                        </td>
                        <td>
                            <b>{{ runner.equipe_name }}</b> - {{ runner.runner_names }} [Doss. {{ runner.dossard }}]
                        </td>

                        <td>
                            <b class="text-accent" style="font-size: 1.1rem">{{ runner.total.temps }}</b>
                        </td>


                    </tr>

                </template>
            </tbody>
            <tbody v-else>
                <tr>
                    <td colspan="5" v-if="filters.sexe != 'Tous' || filters.search != ''" class="text-center">Aucun
                        participant ne
                        correspond à votre recherche</td>
                    <td colspan="5" v-else class="text-center">En attente des résultats</td>
                </tr>
            </tbody>
        </v-table>

        <v-dialog v-model="show_dialog" width="500">
            <v-card>
                <v-card-text>
                    <RunnerDetails :runner="selected_runner"></RunnerDetails>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="secondary" block @click="show_dialog = false">Fermer</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import RunnerDetails from "@/components/Resultats/RunnerDetails.vue";
export default {
    components: {
        RunnerDetails,
    },
    props: [],
    data() {
        return {
            expandedDossard: null,
            show_dialog: false,
            selected_runner: null,
        };
    },
    computed: {
        filters() {
            return this.$store.state.filters;
        },
        filteredRunners() {
            if (!this.$store.state.runners) return [];
            let runners = this.$store.state.runners;

            if (this.$store.state.current_sexe == 'f') {
                runners = runners.filter((runner) => runner.sexe == 'F');
            } else {
                runners = runners.filter((runner) => runner.sexe == 'X');
            }

            const filters = this.$store.state.filters;
            if (filters.search != "") {
                const q = filters.search.toLowerCase();
                runners = runners.filter((runner) => {
                    const names = `${runner.equipe_name || ""} ${runner.runner_names || ""}`.toLowerCase();
                    return names.includes(q);
                });
            }

            return runners;
        },
    },
    methods: {
        runnerKey(runner) {
            return runner.dossard != null ? String(runner.dossard) : null;
        },
        isExpanded(runner) {
            return this.runnerKey(runner) === this.expandedDossard;
        },
        display_runner_details(runner) {

            this.selected_runner = runner;
            this.show_dialog = true;
        },
    },
};
</script>

<style scoped></style>
